/* eslint-disable no-unused-expressions */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState, Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Badge, Dropdown, notification, Table,
} from 'antd';
import {
  CaretDownFilled,
  CaretRightFilled, FilePdfOutlined, LoadingOutlined,
} from '@ant-design/icons';
import SoActions from '@Actions/sales/soActions';
import imageDefault from '@Images/icons/imageDefault.png';
import './style.scss';
import Constants, { QUANTITY } from '@Apis/constants';
import { v4 as uuidv4 } from 'uuid';
import H3Text from '@Uilib/h3Text';

/**
 * ReturnFulfilledLines component
 *
 * @param record
 * @param file
 */
function ReturnFulfilledLines({
  shopifyReturns, cancelReturnFulfillmentLoading, getReturnsLoading, handleDrawerState,
  MONEY, getReturns, selectedSO, cancelReturnFulfillment,
}) {
  useEffect(() => {
    getReturns(selectedSO?.shopify_shop_name, selectedSO?.shopify_order_id, selectedSO?.order_id);
  }, []);

  const returnFulfilledColumns = [
    {
      title: '',
      width: '60px',
      render: (record) => ({
        props: { style: { backgroundColor: !record?.id ? '#ABE09835' : 'white' } },
        children: (
          <Fragment>
            {record?.id ? (
              <div style={{ width: '50px', height: '50px' }}>
                <img style={{ width: '50px', height: '50px', opacity: record?.so_line_object?.product_sku_info?.assets?.[0]?.url ? 1 : 0.15 }} src={`${record?.so_line_object?.product_sku_info?.assets?.[0]?.url ? record?.so_line_object?.product_sku_info?.assets?.[0]?.url : imageDefault}`} />
                <Badge
                  className="fulfilled-qty__badge"
                  count={QUANTITY(record?.quantity, record?.uom_info?.[0]?.precision)}
                />
              </div>
            ) : (
              <div className="rf-table__location-wrapper">
                <div className="rf-table__fg-name">
                  {record?.name}
                  {' '}
                  <CaretRightFilled />
                </div>
                <div className="rf-table__location-wrapper__actions">
                  <div className={`rf-table__location-status ${record?.refundStatus?.toProperCase() === 'Open' ? 'status__open' : 'status__close'}`}>{record?.refundStatus?.toProperCase()}</div>
                  <div className="filters__buttons">
                    <Dropdown
                      overlay={(
                        <div className="header__custom-dropdown" style={{ width: '160px' }}>
                          <div
                            className="header__custom-dropdown__option"
                            onClick={() => {
                              if (!cancelReturnFulfillmentLoading) {
                                const payload = {
                                  shopify_return_id: record.rfId,
                                  shop_name: selectedSO?.shopify_shop_name,
                                };
                                cancelReturnFulfillment(payload, () => {
                                  getReturns(selectedSO?.shopify_shop_name, selectedSO?.shopify_order_id, selectedSO?.order_id);
                                });
                              }
                            }}
                          >
                            <div style={{ fontWeight: '500' }}>{cancelReturnFulfillmentLoading ? <LoadingOutlined /> : 'Cancel Return'}</div>
                          </div>

                          {record?.refundable && (
                            <div
                              className="header__custom-dropdown__option"
                              onClick={() => {
                                handleDrawerState(record);
                              }}
                            >
                              <div style={{ fontWeight: '500' }}>{getReturnsLoading ? <LoadingOutlined /> : 'Initiate Refund'}</div>
                            </div>
                          )}
                        </div>
                      )}
                    >
                      <div className="filter__button" style={{ fontSize: '12px' }}>
                        More
                        <CaretDownFilled />
                      </div>
                    </Dropdown>
                  </div>
                </div>
              </div>
            )}
          </Fragment>),
      }),
      onCell: (item) => {
        if (!item?.id) {
          return { colSpan: 7 };
        }
        return {};
      },
    },
    {
      title: 'PRODUCT',
      render: (item) => (
        <Fragment>

          <div className="fulfilled__product-info__wrapper">
            <div className="fulfilled__product-info">
              <Link
                to={`/inventory/product/view/${item?.so_line_object?.product_sku_info?.product_sku_id}`}
                target="_blank"
              >
                <span style={{ fontSize: '11px' }}>
                  #
                  {item?.so_line_object?.product_sku_info?.internal_sku_code}
                </span>
              </Link>
              <br />
              {item?.so_line_object?.product_sku_info?.product_sku_name}
              <H3Text text={item.remarks} className="quotation__remarks" />
            </div>
            <div className="fulfilled__product-pricing">
              {`${QUANTITY(item?.quantity, item?.so_line_object?.uom_info?.[0]?.precision)} ${item?.so_line_object?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
              &nbsp;
              x
              &nbsp;
              {MONEY(item?.so_line_object?.offer_price * (1 + (item?.so_line_object?.tax_info?.tax_value / 100)))}
            </div>
          </div>
        </Fragment>
      ),
      onCell: (item) => {
        if (!item?.id) {
          return { colSpan: 0 };
        }
        return { colSpan: 6 };
      },
    },

  ];

  /**
   *
   * @param {*} data
   * @return
   */
  const getDataSource = (data) => {
    const finalLines = [];
    if (data?.data?.returns) {
      data?.data?.returns?.filter((item) => item.status?.toUpperCase() !== 'CANCELED').map((uf) => {
        const lines = uf.return_lines;
        finalLines.push({
          rfId: uf.id,
          name: uf.name,
          // refundable: !!uf.refundable,
          refundable: uf?.status !== 'CLOSED',
          refundStatus: uf?.status,
        });
        lines.map((line) => finalLines.push({ ...line, ...line.tenant_info, key: uuidv4() }));
        // return uf;
      });
    }
    return finalLines;
  };

  return (
    <Fragment>
      <div className="view-so-rf-table-wrapper">
        <Table
          showHeader
          title={() => `Returned Items (${getDataSource(shopifyReturns)?.filter((item) => item?.id)?.length || 0})`}
          loading={cancelReturnFulfillmentLoading || getReturnsLoading}
          size="small"
          columns={returnFulfilledColumns}
          dataSource={getDataSource(shopifyReturns)}
          pagination={false}
          bordered
          scroll={{ x: true }}

        />
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({ SOReducers, UserReducers }) => ({
  cancelReturnFulfillment: SOReducers.cancelReturnFulfillment,
  cancelReturnFulfillmentLoading: SOReducers.cancelReturnFulfillmentLoading,
  getReturnsLoading: SOReducers.getReturnsLoading,
  shopifyReturns: SOReducers.shopifyReturns,
  selectedSO: SOReducers.selectedSO,
  MONEY: UserReducers.MONEY,
});

const mapDispatchToProps = (dispatch) => ({
  cancelReturnFulfillment: (payload, callback) => dispatch(SoActions.cancelReturnFulfillment(payload, callback)),
  getReturns: (shopName, shopifyOrderId, orderId) => dispatch(SoActions.getReturns(shopName, shopifyOrderId, orderId)),
});

ReturnFulfilledLines.propTypes = {
  shopifyReturns: PropTypes.any,
  cancelReturnFulfillmentLoading: PropTypes.bool,
  handleDrawerState: PropTypes.any,
  selectedSO: PropTypes.any,
  getReturnsLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReturnFulfilledLines));
